import * as React from "react";
import { Button } from "antd";
import { openProductsPageWithProduct } from "./openProductNavigation";

interface OpenProductLinkProps {
  productId?: number | null;
  productType: string;
  children: React.ReactNode;
}

export function OpenProductLink({
  productId,
  productType,
  children,
}: OpenProductLinkProps) {
  if (productId == null || !Number.isFinite(productId) || productId < 1) {
    return <>{children}</>;
  }

  return (
    <Button
      type="link"
      style={{ padding: 0, height: "auto", whiteSpace: "normal", textAlign: "left" }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openProductsPageWithProduct(productId, productType);
      }}
    >
      {children}
    </Button>
  );
}